import { object, ref, string } from 'yup';
import { passwordValidation } from '../../../components/PasswordField/config';

export const initialValues = {
  email: '',
  password: '',
  passwordConfirm: '',
};

export const validationSchema = [
  object().shape({
    email: string().required('error.input.required').email('error.input.email'),
  }),
  object().shape({
    password: passwordValidation.required('error.input.required'),
    passwordConfirm: string()
      .required('error.input.required')
      .oneOf([ref('password')], 'error.input.password_mismatch'),
  }),
];
